.callout {
  background-color: rgba(0, 0, 0, 0.05);
  font-size: 14px;
  padding: 10px 30px;
  max-height: 55vh;
  overflow-y: auto;
}